import styled, { keyframes } from 'styled-components';

// Styled custom LIVE pill with pulsing dot
const pulse = keyframes`
  0% { transform: scale(1); opacity: 1; }
  70% { transform: scale(1.6); opacity: 0; }
  100% { transform: scale(1); opacity: 0; }
`;

export const LiveBadgePill = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 2px 8px;
  height: 20px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  color: #fff;
  background: linear-gradient(90deg, #ff3b30 0%, #ff6b6b 100%);
  box-shadow: 0 2px 8px rgba(255, 59, 48, 0.35);
  position: relative;
  pointer-events: none;

  &::before {
    content: '';
    position: relative;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #fff;
    box-shadow:
      0 0 0 2px rgba(255, 255, 255, 0.35) inset,
      0 0 10px rgba(255, 255, 255, 0.5);
  }

  &::after {
    content: '';
    position: absolute;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: rgba(255, 59, 48, 0.6);
    animation: ${pulse} 1.6s ease-out infinite;
    transform-origin: center;
    left: 8px;
    top: 6px;
  }
`;
